import AlertBlue from "@/app/components/ui/Alerts/Blue";
import AlertError from "@/app/components/ui/Alerts/Error";
import SimpleBadge from "@/app/components/ui/Badges/SimpleBadge";
import { useTransferOrderDetailsAPI } from "@/app/hooks/api_hooks/Inventory/ClinicToClinicTransfer/useTransferOrderDetailsAPI";
import { useGrnDetailAPI } from "@/app/hooks/api_hooks/Inventory/PO/useGrnDetailAPI";
import { usePurchaseOrderDetailsAPI } from "@/app/hooks/api_hooks/Inventory/PO/usePurchaseOrderDetailsAPI";
import { useMappedConstants } from "@/app/hooks/useMappedConstants";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { IInventoryState } from "@/app_redux/reducers/slices/auth/inventory_slice";
import { format, fromUnixTime } from "date-fns";
import { startCase, toNumber } from "lodash";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";

const GoodsReceiptNoteHeaderComponent = () => {
  let isDetailsFetched = false;
  const [params, _setparams] = useSearchParams();
  const { POStatusBadgeColor } = useMappedConstants();
  const { getRouteKey } = useRouter();
  const { GRNDetails, purchaseOrderDetails } = useRouteInfo(getRouteKey("INVENTORY", "id"))?.routeState
    ?.state as IInventoryState;
  const [currentDate, setCurrentDate] = useState("");
  const po_id = params?.get("po_id");
  const to_id = params?.get("to_id");

  if (po_id) {
    localStorage.setItem("PO_ID", po_id);
  }
  if (to_id) {
    localStorage.setItem("TO_ID", to_id);
  }
  const navigate = useNavigate();
  const [activeButton, setActiveButton] = useState(
    location.pathname.split("/").at(-1) == "pending-goods" ? "PENDING_GOODS" : "GRN_DONE",
  );
  const { execute: fetchGrnDetail } = useGrnDetailAPI();
  const { execute: fetchPOdetails } = usePurchaseOrderDetailsAPI();
  const { toDetails } = useRouteInfo("INVENTORY")?.routeState?.state as IInventoryState;
  const transferOrderDetails = useTransferOrderDetailsAPI();

  useEffect(() => {
    const date = new Date();
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${year}-${month}-${day}`;
    setCurrentDate(formattedDate);
  }, []);

  useEffect(() => {
    if (po_id && !isDetailsFetched) {
      fetchGrnDetail(po_id);
      isDetailsFetched = true;
    } else if (to_id && !isDetailsFetched) {
      isDetailsFetched = true;
    }
  }, [po_id, to_id]);

  useEffect(() => {
    if (to_id) transferOrderDetails(to_id);
  }, [to_id]);

  useEffect(() => {
    if (po_id) {
      fetchPOdetails(po_id);
    }
  }, [po_id]);

  return (
    <div>
      <h2 className="shadow-md px-2 py-3 rounded-md font-semibold text-[10px] sm:text-xs 2xl:text-sm">
        Goods Receipt Note
      </h2>
      {to_id ? (
        <h3 className="2xl:mt-2 px-2 py-3 font-medium text-[10px] sm:text-xs 2xl:text-sm ">
          GRN for #{toDetails?.transfer_order_number}
        </h3>
      ) : (
        <h3 className="2xl:mt-2 px-2 py-1 font-medium text-[10px] sm:text-xs 2xl:text-sm">
          GRN for #{GRNDetails?.po_number}
          {purchaseOrderDetails && (
            <span className="ml-2">
              <SimpleBadge
                label={startCase(purchaseOrderDetails?.po_status?.split("_").join(" "))}
                colorClassName={POStatusBadgeColor[purchaseOrderDetails?.po_status]}
              />
            </span>
          )}
        </h3>
      )}
      <div className="flex gap-5 px-2 py-1 ">
        {to_id ? (
          <>
            <div className="flex item-center gap-1">
              <p className="text-[10px] sm:text-xs 2xl:text-sm">Sender Clinic:</p>
              <p className="text-[10px] sm:text-xs 2xl:text-sm">
                {toDetails?.transfer_order_clinic_details?.sender_clinic_name}
              </p>
            </div>
            <div className="flex item-center gap-1">
              <p className="text-[10px] sm:text-xs 2xl:text-sm">Receiver Clinic:</p>
              <p className="text-[10px] sm:text-xs 2xl:text-sm">
                {toDetails?.transfer_order_clinic_details?.receiver_clinic_name}
              </p>
            </div>
            <div className="flex item-center gap-1">
              <p className="text-[10px] sm:text-xs 2xl:text-sm">Requested Date:</p>
              <p className="text-[10px] sm:text-xs 2xl:text-sm">
                {toDetails?.created_at ? format(fromUnixTime(toNumber(toDetails?.created_at)), "dd-MM-yyyy") : "N/A"}
              </p>
            </div>
            <div className="flex item-center gap-1">
              <p className="text-[10px] sm:text-xs 2xl:text-sm">Received Date:</p>
              <p className="text-[10px] sm:text-xs 2xl:text-sm">{currentDate}</p>
            </div>
          </>
        ) : (
          <>
            <div className="flex item-center gap-1">
              <p className="text-[10px] sm:text-xs 2xl:text-sm">Clinic Name:</p>
              <p className="text-[10px] sm:text-xs 2xl:text-sm">
                {GRNDetails?.primary_purchase_info?.clinic_details?.ship_to_clinic_name as any}
              </p>
            </div>
            <div className="flex item-center gap-1">
              <p className="text-[10px] sm:text-xs 2xl:text-sm">VMS Category:</p>
              <p className="text-[10px] sm:text-xs 2xl:text-sm">
                {GRNDetails?.primary_purchase_info?.vms_category_details?.variant_category_name}
              </p>
            </div>
            <div className="flex item-center gap-1">
              <p className="text-[10px] sm:text-xs 2xl:text-sm">Vendor:</p>
              <p className="text-[10px] sm:text-xs 2xl:text-sm">
                {GRNDetails?.primary_purchase_info?.vendor_details?.vendor_name}
              </p>
            </div>
            <div className="flex item-center gap-1">
              <p className="text-[10px] sm:text-xs 2xl:text-sm">Requested Date:</p>
              <p className="text-[10px] sm:text-xs 2xl:text-sm">{GRNDetails?.primary_purchase_info?.delivery_date}</p>
            </div>
            <div className="flex item-center gap-1">
              <p className="text-[10px] sm:text-xs 2xl:text-sm">Received Date:</p>
              <p className="text-[10px] sm:text-xs 2xl:text-sm">{currentDate}</p>
            </div>
          </>
        )}
      </div>
      {po_id && (
        <div className="mt-2 mb-2">
          {purchaseOrderDetails && purchaseOrderDetails?.po_status === "issue_in_grn" && (
            <AlertError
              title="Issue In GRN"
              description={
                <div className="text-[10px] sm:text-xs 2xl:text-sm">
                  <p className="font-semibold">
                    Issue Raised : <span className="font-normal">{purchaseOrderDetails?.raised_error_reason}</span>{" "}
                  </p>
                </div>
              }
            />
          )}
          {purchaseOrderDetails?.po_status === "closed" && (
            <AlertBlue
              title={
                <div>
                  <p className="font-semibold">You cannot do any edit here now.</p>
                  <p className="">
                    The PO has been marked as closed , waiting for final approval from the central team.
                  </p>
                </div>
              }
            />
          )}
        </div>
      )}
      <div className="flex item-center gap-1 mt-3 ">
        <button
          type="button"
          onClick={() => {
            setActiveButton("PENDING_GOODS");
            if (po_id) {
              navigate(`/app/inventory/pending-goods?po_id=${po_id}`);
            } else if (to_id) {
              navigate(`/app/inventory/pending-goods?to_id=${to_id}`);
            }
          }}
          className={`text-[10px] sm:text-xs 2xl:text-sm rounded-3xl px-4 py-2 ${
            activeButton === "PENDING_GOODS" ? "bg-black text-white" : "bg-white text-black border-black border"
          }`}
        >
          Pending Goods
        </button>
        <button
          type="button"
          onClick={() => {
            setActiveButton("GRN_DONE");
            if (po_id) {
              navigate(`/app/inventory/goods-done?po_id=${po_id}`);
            } else if (to_id) {
              navigate(`/app/inventory/goods-done?to_id=${to_id}`);
            }
          }}
          className={`text-[10px] sm:text-xs 2xl:text-sm rounded-3xl px-4 py-2 ${
            activeButton === "GRN_DONE" ? "bg-black text-white" : "bg-white text-black border-black border"
          }`}
        >
          GRN Done
        </button>
      </div>
    </div>
  );
};

export default GoodsReceiptNoteHeaderComponent;
